import { css } from 'styled-components';

const Link = css`
  color: ${(props) => props.theme.palette.blue[100]};
  font-size: ${(props) => props.theme.typography.sizes.small};
  font-family: ${({ theme }) => theme.typography.fonts.default};
  :hover {
    color: ${(props) => props.theme.palette.darkBlue[100]};
    cursor: pointer;
  }
`;

export default Link;
